import React from "react";
// import Directory from '../../components/directory/directory.component';
import FormInput from "../../components/form-input/form-input.component";
import { Link } from "react-router-dom";
import { getPetInfo } from "../../firebase/firebase.utils";
import { Redirect } from "react-router";
import CustomButton from "../../components/custom-button/custom-button.component";
import logo from "../../assets/logo_4.png";
import "./homepage.styles.scss";

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: "",
      hasResult: false,
      data: {},
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    getPetInfo(this.state.searchTerm).then((value) => {
      if (value) {
        this.setState({ hasResult: true, data: value });
      }else {
        alert("Không tìm thấy thú cưng nào. Vui lòng thử lại!");
      }
    });
  };

  handleChange = (event) => {
    this.setState({ searchTerm: event.target.value });
  };

  render() {
    return (
      <div className="homepage">
        <div>
          <Link className="logo-container" to="/">
            <img className="logo" src={logo} alt="logo"/>
          </Link>
        </div>
        <form onSubmit={this.handleSubmit}>
          <FormInput
            name="search"
            type="text"
            handleChange={this.handleChange}
            value={this.state.searchTerm}
            label="Điền số chip để bắt đầu tra cứu"
            required
          />
          <div className="buttons">
            <CustomButton type="submit"> Tìm kiếm </CustomButton>
          </div>
        <Link to='/admin' className="login">Đăng nhập</Link>
        </form>
        {this.state.hasResult ? (
          <Redirect
            push
            to={{
              pathname: "/petdetails",
              state: { referrer: this.state.data, microchip: this.state.searchTerm },
            }}
          />
        ) : (
          <span></span>
        )}
      </div>
    );
  }
}

export default HomePage;
